import {createSignal} from '@pexip/signal';

export const skippedStepByStepSignal = createSignal({
    name: 'step-by-step:skipped',
});
